import { compressedFileSizeLimit } from 'constants/constants';
import store from 'store/storeConfig';
import { PatientStatus } from 'constants/enums';

import { generateResizedCanvas } from './UI';

/**
 * Return the base64 URL with the compression ratio specified.
 * Keep compressing until the image is under 100kb
 * Will throw an error if the compression ratio gets too low.
 */
export const _generateImageUrl = (
  resizedCanvas: HTMLCanvasElement,
  ratio: number
): string | null => {
  if (ratio <= 0.5) {
    return null;
  }

  const url = resizedCanvas.toDataURL('image/png', ratio);
  if (url.length > compressedFileSizeLimit) {
    return _generateImageUrl(resizedCanvas, ratio - 0.1);
  }
  return url;
};

/**
 * Generate a base64 URL of the image with a resized image resolution of 128x128
 */
export const generateImageUrl = (
  originalCanvas: HTMLCanvasElement | HTMLImageElement,
  resizedImageResolution: number
): string | null => {
  return _generateImageUrl(generateResizedCanvas(originalCanvas, resizedImageResolution), 1.0);
};

export const getPatientStatusOptions = () => {
  const { intl } = store.getState();
  return [
    {
      label: intl.messages['referredKey'],
      value: PatientStatus.REFERRED,
      automatic: false
    },
    {
      label: intl.messages['devicesOrderedKey'],
      value: PatientStatus.DEVICE_ORDERED,
      automatic: true
    },
    {
      label: intl.messages['devicesShippedKey'],
      value: PatientStatus.DEVICE_SHIPPED,
      automatic: true
    },
    {
      label: intl.messages['firstReadingTransmittedKey'],
      value: PatientStatus.FIRST_READING_TRANSMITTED,
      automatic: true
    },
    {
      label: intl.messages['enrolledKey'],
      value: PatientStatus.ENROLLED,
      automatic: false
    },
    {
      label: intl.messages['pausedKey'],
      value: PatientStatus.PAUSED,
      automatic: false
    },
    {
      label: intl.messages['toBeArchivedKey'],
      value: PatientStatus.TO_BE_ARCHIVED,
      automatic: false
    },
    {
      label: intl.messages['archivedKey'],
      value: PatientStatus.ARCHIVED,
      automatic: false
    }
    /*{
      label: intl.messages['offboardedKey'],
      value: '150',
      automatic: false,
    },*/
  ];
};
